import React, { useEffect } from "react";
import { connectLoginPopUp } from "./loginPopUp.connect";
import { createPortal } from "react-dom";
import { CONFIG } from "../../config/api.config";
import LogInStep from "./LogInStep/LogInStep";
import SignUpTab from "./SignUpTab/SignUpTab";
import ForgotPasswordTab from "./ForgotPassword/ForgotPasswordTab";
import SVG_CloseIcon from "../../assets/images/svgs/close-dark.svg?react";
const modalRoot = document.querySelector("#modal-root");

const LoginPopUp = ({
  open,
  onDidDismiss,
  auth,
  recaptcha,
  actions,
  version,
  B2C,
  scrollPosition,
  isDetailedPromo,
  promoInfo,
  isTermCondition,
  // tab = 1
  tab = 1,
  elementsParams,
  signUp,
  logo,
}) => {
  useEffect(() => {
    if (!onDidDismiss) {
      //  setTabButton(1)
      actions.setTab(1);
    }
  }, [onDidDismiss]);

  const width =
    elementsParams && elementsParams?.clientWidth
      ? elementsParams?.clientWidth
      : window.innerWidth;

  return createPortal(
    <>
      {!!open && (
        <div
          id="popup-modal"
          className="z-[1000] absolute top-0 right-[0.5px] md:right-0 overflow-hidden flex w-full h-screen min-h-[100dvh] items-center justify-center bg-bg_CasinoPopupBg"
          onClick={() => onDidDismiss(false)} // Close modal on outside click
        >
          <div
            className="z-2 popUpBoxShadow popUpOpenAnimation absolute w-[90%] sm:w-[85%] md:w-[70%] lg:w-[600px] max-w-[600px] bg-bg_loginPopupBg p-2 xs:p-5 rounded-md"
            onClick={(e) => e.stopPropagation()} // Prevent modal clicks from closing it
          >
            <div
              className="transition-all mb-2 ease-in-out duration-200 hover:scale-105 absolute top-2 right-2"
              onClick={() => onDidDismiss(false)}
            >
              <SVG_CloseIcon />
            </div>

            <div className="logo w-full hidden lg:flex items-center justify-center mb-4">
              {/* <img
             src={`/assets/images/${window.location.hostname
               .replace("www.", "")
               .replace("app.", "")}/logo.png`}
             alt="logo"
             className="w-72 h-auto"
             width="100"
             height="100"
           /> */}
              {/* <img
                src={logo}
                alt="logo"
                className="w-72 h-auto"
                width="100"
                height="100"
                style={{
                  filter:
                    "invert(93%) sepia(83%) saturate(7422%) hue-rotate(-5deg) brightness(91%) contrast(108%)",
                }}
              /> */}
            </div>

            {tab === 1 && <LogInStep onDidDismiss={onDidDismiss} />}

            {(CONFIG.showSignupOption ||
              (CONFIG.showSignupbyRefer && !!signUp.referCode)) &&
              tab === 2 && <SignUpTab onDidDismiss={onDidDismiss} />}

            {tab === 3 && (
              <ForgotPasswordTab onDidDismiss={onDidDismiss} width={width} />
            )}
          </div>
        </div>
      )}
    </>,
    modalRoot
  );
};

export default connectLoginPopUp()(LoginPopUp);
